








import { Vue, Component } from "vue-property-decorator";

@Component
export default class Login extends Vue {
  private bc: BroadcastChannel;
  private kioskName: string;

  constructor() {
    super();
    console.log("ctor Login");
    this.bc = new BroadcastChannel("login-protocol");
    this.bc.onmessage = this.onReceiveMessage;

    this.kioskName = this.$route.query.kioskName
      ? this.$route.query.kioskName[0] || "jusda-kiosk"
      : "jusda-kiosk";
  }

  mounted() {
    const { kiwi } = window;
    if (kiwi) {
      kiwi.on("barcodeScanned", this.barcodeScanned);
    } else {
      console.warn("kiwi barcode is not supported");
    }
  }

  private onReceiveMessage(ev: MessageEvent) {
    const { type } = ev.data;
    if (type === "verify") {
      if (this.currentCardId) {
        this.sendLogin(this.currentCardId);
      } else {
        this.sendLogout();
      }
    }
  }

  private makeid() {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < 16; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  private debugTimer = -1;
  private loginDebug() {
    if (this.debugTimer) {
      clearInterval(this.debugTimer);
    }
    const random = this.makeid();
    this.barcodeScanned(random);
    this.debugTimer = setInterval(() => {
      this.barcodeScanned(random);
    }, 1000);
  }

  private logoutDebug() {
    clearInterval(this.debugTimer);
  }

  private sendLogin(cardId: string) {
    this.bc.postMessage({
      type: "login"
    });
  }

  private sendLogout() {
    this.bc.postMessage({
      type: "logout"
    });
  }

  private login(cardId: string) {
    console.info("login");
    this.sendLogin(cardId);
  }

  private goHome() {
    console.info("goHome");
    const { kiwi } = window;
    if (kiwi) {
      setTimeout(() => {
        const kiosk = new kiwi.remote(this.kioskName);
        if (kiosk) {
          console.info("home click");
          kiosk.buttonClick("home");
        }
      }, 1000);
    }
  }

  private logout() {
    this.sendLogout();
    console.info("logout");
    this.currentCardId = "";
    this.currentSession = false;
    this.nonFirstScanned = false;
  }

  private scanIntervalHandle = -1;
  private currentCardId = "";
  private nonFirstScanned = false;
  private currentSession = false;

  private barcodeScanned(cardId: string) {
    if (!this.nonFirstScanned) {
      this.nonFirstScanned = true;
      this.currentSession = true;

      this.currentCardId = cardId;
      this.login(this.currentCardId);

      this.scanIntervalHandle = window.setInterval(
        this.checkCardAvailability,
        2000
      );
      return;
    }

    if (cardId === this.currentCardId) {
      // Pokud je cislo prichozi karty porad stejne
      this.currentSession = true;
      return;
    }
    // Prislo cislo jine karty
    this.currentSession = false;
  }

  private checkCardAvailability() {
    if (this.currentSession) {
      this.currentSession = false;
      return;
    }

    this.logout();
    this.goHome();
    window.clearInterval(this.scanIntervalHandle);
  }
}
